import { Box, Button, Card, CardContent, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import {
  disableDeleteNatgwSchedule,
  enableDeleteNatgwSchedule,
  getDeleteNatgwScheduleState,
} from "../../../services/aws/event_bridge";

/**
 * Component for managing event bridge schedules functionality.
 *
 * @component
 * @example
 * return (
 *   <EventBridgeSchedules />
 * )
 *
 * @returns {JSX.Element} Card containing event bridge schedules controls with enable/disable buttons
 */
function EventBridgeSchedules() {
  const [deleteNatgwScheduleEnabled, setDeleteNatgwScheduleEnabled] = useState(false);

  useEffect(() => {
    fetchStatus();
  }, []);

  /**
   * Fetch current event bridge schedules status
   */
  const fetchStatus = async () => {
    try {
      const response = await getDeleteNatgwScheduleState();
      const json = await response.json();

      if (json && json.status === "success") {
        setDeleteNatgwScheduleEnabled(json.data.state === "ENABLED");
      }
    } catch (error) {
      console.error("Error fetching delete natgw schedule status:", error);
    }
  };

  /**
   * Enable delete natgw schedule
   */
  const handleEnableDeleteNatgwSchedule = async () => {
    try {
      const response = await enableDeleteNatgwSchedule();
      if (response && response.status === "success") {
        // Refresh the status after enabling
        await fetchStatus();
      }
    } catch (error) {
      console.error("Failed to enable delete natgw schedule:", error);
    }
  };

  /**
   * Disable delete natgw schedule
   */
  const handleDisableDeleteNatgwSchedule = async () => {
    try {
      const response = await disableDeleteNatgwSchedule();
      if (response && response.status === "success") {
        // Refresh the status after disabling
        await fetchStatus();
      }
    } catch (error) {
      console.error("Failed to disable delete natgw schedule:", error);
    }
  };

  return (
    <Card sx={{ width: "100%" }}>
      <CardContent>
        <Typography variant="h6" component="div" sx={{ m: 2 }}>
          Status: {deleteNatgwScheduleEnabled ? "ENABLED" : "DISABLED"}
        </Typography>
        <Box sx={{ display: "flex", gap: 2, m: 2 }}>
          <Button
            variant="contained"
            color="primary"
            disabled={deleteNatgwScheduleEnabled}
            onClick={handleEnableDeleteNatgwSchedule}
          >
            Enable Delete Natgw Schedule
          </Button>
          <Button
            variant="contained"
            color="error"
            disabled={!deleteNatgwScheduleEnabled}
            onClick={handleDisableDeleteNatgwSchedule}
          >
            Disable Delete Natgw Schedule
          </Button>
        </Box>
      </CardContent>
    </Card>
  );
}

export default EventBridgeSchedules;
